import { AdditiveBorderType, BadgeButtonType, BadgeIconType } from "../../Types/UiKitsType";

export const badgesContextualSubTitle = [
    {
        text: 'Use the',
        code: '.badge '
    },
    {
        text: 'utility class to make more badges.'
    }
];

export const pillsContextualSubTitle = [
    {
        text: 'Use the',
        code: '.rounded-pill'
    },
    {
        text: ' utility class to make badges more rounded with a larger ',
        code: 'border-radius'
    },
    {
        text: '.'
    }
];

export const numberPillsSubTitle = [
    {
        text: 'Use the',
        code: '.rounded-circle'
    },
    {
        text: ' utility class to make badges more rounded with a larger ',
        code: 'border-radius'
    },
    {
        text: '.'
    }
];

export const badgeWithIconSubTitle = [
    {
        text: 'Use the',
        code: '.badge '
    },
    {
        text: 'utility class to make more icons.'
    }
]

export const numberBadgeSubTitle = [
    {
        text: 'Use the',
        code: '.badge'
    },
    {
        text: ' utility class to make number of more badges.'
    }
];

export const roundedPillSubTitle = [
    {
        text: 'Use the',
        code: '.rounded-pill'
    },
    {
        text: ' utility class to make icons badges more rounded with a larger ',
        code: 'border-radius'
    },
    {
        text: '.'
    }
]

export const badgeHeadingSubTitle = [
    {
        text: 'All html headings,',
        code: '<h1>'
    },
    {
        text: 'through ',
        code: '<h6>'
    },
    {
        text: ', are available in ',
        code: '.badge '
    },
    {
        text: 'tags.'
    }
];

export const badgeButtonSubTitle = [
    {
        text: '',
        code: '.badge'
    },
    {
        text: ' can be used as part of ',
        code: '.btn'
    },
    {
        text: ' to provide a icons.'
    }
]

export const badgesData: AdditiveBorderType[] = [
    {
        class: 'primary',
        text: 'Primary'
    },
    {
        class: 'secondary',
        text: 'Secondary'
    },
    {
        class: 'success',
        text: 'Success'
    },
    {
        class: 'info',
        text: 'Info'
    },
    {
        class: 'warning text-dark',
        text: 'Warning'
    },
    {
        class: 'danger',
        text: 'Danger'
    },
    {
        class: 'light text-dark',
        text: 'Light'
    },
    {
        class: 'dark tag-pills-sm-mb',
        text: 'Dark'
    }
]

export const pillsData: AdditiveBorderType[] = [
    {
        class: 'primary',
        text: 'Primary'
    },
    {
        class: 'secondary',
        text: 'Secondary'
    },
    {
        class: 'success',
        text: 'Success'
    },
    {
        class: 'info',
        text: 'Info'
    },
    {
        class: 'warning text-dark',
        text: 'Warning'
    },
    {
        class: 'danger',
        text: 'Danger'
    },
    {
        class: 'light text-dark',
        text: 'Light'
    },
    {
        class: 'dark tag-pills-sm-mb',
        text: 'Dark'
    }
]

export const numberBadgesData: AdditiveBorderType[] = [
    {
        class: 'primary',
        text: '1'
    },
    {
        class: 'secondary',
        text: '2'
    },
    {
        class: 'success',
        text: '3'
    },
    {
        class: 'info',
        text: '4'
    },
    {
        class: 'warning text-dark',
        text: '5'
    },
    {
        class: 'danger',
        text: '6'
    },
    {
        class: 'light text-dark',
        text: '7'
    },
    {
        class: 'dark text-light',
        text: '8'
    }
]

export const numberPillsData: AdditiveBorderType[] = [
    {
        class: 'primary',
        text: '1'
    },
    {
        class: 'secondary',
        text: '2'
    },
    {
        class: 'success',
        text: '3'
    },
    {
        class: 'info',
        text: '4'
    },
    {
        class: 'warning text-dark',
        text: '5'
    },
    {
        class: 'danger',
        text: '6'
    },
    {
        class: 'light text-dark',
        text: '7'
    },
    {
        class: 'dark',
        text: '8'
    }
]

export const badgeIconData: BadgeIconType[] = [
    {
        color: 'primary',
        class: 'b-ln-height',
        iconName: 'DollarSign'
    },
    {
        color: 'secondary',
        class: 'b-ln-height',
        iconName: 'Headphones'
    },
    {
        color: 'success',
        class: 'b-ln-height',
        iconName: 'Link2'
    },
    {
        color: 'info',
        class: 'b-ln-height',
        iconName: 'GitHub'
    },
    {
        color: 'warning',
        class: 'b-ln-height text-dark',
        iconName: 'Award'
    },
    {
        color: 'danger',
        class: 'b-ln-height',
        iconName: 'Activity'
    },
    {
        color: 'light',
        class: 'b-ln-height text-dark',
        iconName: 'Heart'
    },
    {
        color: 'dark',
        class: 'text-light',
        iconName: 'Mail'
    }
]

export const roundedPillData: BadgeIconType[] = [
    {
        class: 'primary',
        iconName: 'DollarSign'
    },
    {
        class: 'secondary',
        iconName: 'Headphones'
    },
    {
        class: 'success',
        iconName: 'Link2'
    },
    {
        class: 'info',
        iconName: 'GitHub'
    },
    {
        class: 'warning text-dark',
        iconName: 'Award'
    },
    {
        class: 'danger',
        iconName: 'Activity'
    },
    {
        class: 'light text-dark',
        iconName: "Heart"
    },
    {
        class: 'dark text-light',
        iconName: "Mail"
    }
]

export const badgeButtonData: BadgeButtonType[] = [
    {
        class: 'primary',
        text: 'Messages',
        iconName: 'Mail'
    },
    {
        class: 'secondary',
        text: 'notifications',
        iconName: 'Bell'
    },
    {
        class: 'success',
        text: 'Update available',
        iconName: 'Settings'
    },
    {
        class: 'info',
        text: 'Playing Now',
        iconName: 'Music'
    },
    {
        class: 'warning text-dark',
        text: '1.2 GB Used',
        iconName: 'AlertTriangle'
    }
];

